// extracted by mini-css-extract-plugin
export default {"grocery_list":"GroceryList_grocery_list__uhNVr","no_item":"GroceryList_no_item__Tgjrc"};